import React from "react";
import { LangLink as Link } from "@/components/LangLink";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="404 — Faqja nuk u gjet" noindex />
      <section className="container-akm flex min-h-[60vh] flex-col items-start justify-center py-20">
        <div className="font-display text-7xl font-extrabold tracking-tight text-[#FF7A00]">404</div>
        <h1 className="h1-akm mt-4">Kjo faqe nuk ekziston</h1>
        <p className="lead mt-3 max-w-xl">Faqja që po kërkoni nuk gjendet. Mund të ketë ndryshuar lidhja ose ka pasur një gabim shtypi.</p>
        <div className="mt-6 flex gap-3">
          <Link to="/" className="btn-primary">Kthehu te Kreu</Link>
          <Link to="/platforma" className="btn-ghost">Shiko Platformën</Link>
        </div>
      </section>
    </>
  );
}
